import React, { useEffect } from "react";
import { connect } from "react-redux";
import { setupNavigation } from "../redux/actions/navItemsActions";
import PropTypes from "prop-types";
import "./Home.css";

function PrivacyPolicy({ setupNavigation }) {

    const navigationItems =
    {
        sections: [{
            name: 'Admin',
            items: [
                {
                    path: '/about',
                    text: 'About JustGoRide',
                    icon: 'fas fa-info-circle'
                },
                {
                    path: '/about/contact',
                    text: 'Contact',
                    icon: 'far fa-at'
                },
                {
                    path: '/about/termsandconditions',
                    text: 'Terms and Conditions',
                    icon: 'fas fa-file-signature'
                },
                {
                    path: '/about/privacypolicy',
                    text: 'Privacy Policy',
                    icon: 'fas fa-user-secret'
                }
            ]
        }]
    };

    useEffect(() => {
        document.title = "Privacy and Cookie Policy | JustGoRide";
        setupNavigation(navigationItems);

    }, []);

    return (
        <div className="policy row justify-content-center mt-4 mb-4">
            <div className="col-10">
                <img className="about-logo" alt="JustGoRide" src="/resources/images/new-email-logo.png" />
                <div className="page-content-head text-center mb-5">
                    <h2><span className="head-icon fas fa-user-secret"></span> Privacy and Cookie Policy</h2>
                    <div className="text-muted">Last Updated: 25/04/2020</div>
                </div>
                <h3>Introduction</h3>
                <p>
                   JustGoRide respects your privacy and is committed to protecting your personal data.  
                   This privacy policy informs you about how we look after your personal data when you 
                   visit our website (regardless of where you visit it from). 
                   The policy also tells you about your privacy rights and how the law protects you under 
                   the General Data Protection Regulation (“GDPR”) and Data Protection Act 2018 (and related 
                   legislation) governing the collection and use of personal data.
                </p>
                <h3>Purpose</h3>
                <ol>
                    <li>
                        <p>This privacy policy aims to give you information as to how JustGoRide collects and processes your 
                        personal data through your use of our website, including any data you may provide through our website.</p>
                    </li>
                    <li>
                        <p>This website is not intended for children and we do not knowingly collect data relating to children.</p>
                    </li>
                    <li>
                        <p>It is important that you read this privacy policy, together with any other privacy notice or fair processing 
                        notice we may provide on specific occasions when we are collecting or processing personal data about you so 
                        that you are fully aware of how and why we are using your data.  This privacy policy supplements any other 
                        notices and is not intended to override them.</p>
                    </li>  
                </ol>
                <h3>Controller</h3>
                <ol start="4">
                    <li>
                        <p>JustGoRide is the controller and is responsible for your personal data (referred to as “JustGoRide”, “we”, “us” 
                        or “our” in this privacy policy).</p>
                    </li>
                    <li>
                        <p>You have the right to make a complaint at any time to the Information Commissioner’s Office (ICO), the UK 
                        supervisory authority for data protection issues.  However, we would appreciate the opportunity to deal with any 
                        concerns you may have before you approach the ICO, so please contact us in the first instance.</p>
                    </li>
                </ol>
                <h3>Your duty to inform us of changes</h3>
                <ol start="6">    
                    <li>
                        It is important that the personal data we hold about you is accurate and current.  Please keep us informed if your
                        personal data changes during your relationship with us.
                    </li>
                </ol>
                <h3>Third party links</h3>
                <ol start="7">    
                    <li>
                        This website may include links to third party websites and applications.  Clicking on those links or enabling those 
                        connections may allow third parties to collect or share data about you.  We do not control third party websites and 
                        are not responsible for their privacy statements.  When you leave our website we encourage you to read the privacy 
                        notice of every website you visit.
                    </li>
                </ol>
                <h3>The data we collect about you</h3>
                <ol start="8">    
                    <li>
                        <p>
                            Personal data, or personal information, means any information about an individual from which that person can be 
                            identified.  It does not include data where the identity has been removed (ie. anonymous data).
                        </p>
                    </li>
                    <li>
                        <p>
                            We do not usually require you to reveal personal information about yourself on our website.  There may be times, 
                            however, when we need personal information from you in order to answer your enquiries more effectively, to improve 
                            the content of our website or to conduct internal marketing analysis.
                        </p>
                    </li>
                    <li>
                        <p>
                            We may collect, use, store and transfer different kinds of personal data about you which we have grouped together as
                            follows:
                        </p>
                        <ul>
                            <li>
                                <b>Identity Data</b> includes your name, title, date of birth and gender;
                            </li>
                            <li>
                                <b>Contact Data</b> includes email addresses and telephone numbers;
                            </li>
                            <li>
                                <b>Technical Data</b> includes internet protocol (IP) address, browser type and version, operating system and
                                platform and other technology on the devices you use to access this website;
                            </li>
                            <li>
                                <b>Profile Data</b> includes your interests, preferences, feedback and any survey responses;
                            </li>
                            <li>
                                <b>Usage Data</b> includes information about how you use our website, products and services; and
                            </li>
                            <li>
                                <b>Marketing and Communications Data</b> includes your preferences in receiving marketing from us and our third
                                parties and your communication preferences.
                            </li>
                        </ul>
                        <br/>
                        <p>
                            We may also collect, use and share data such as statistical or demographic data (“Aggregated Data”) for any purpose.
                            Aggregated Data may be derived from your personal data but is not considered personal data in law as this data doesn’t
                            directly or indirectly reveal your identity.  For example, we may aggregate your Usage Data to calculate the percentage
                            of users accessing a specific website feature.  However, if we combine or connect Aggregated Data with your personal
                            data so that it can directly or indirectly identify you, we treat the combined data as personal data which will be used
                            in accordance with this privacy policy.
                        </p>
                        <p>
                            We do not collect any “Special Categories” of personal data about you (this includes details such as your race or
                            ethnicity, religious beliefs, political opinions or health data).  Neither do we collect any information about criminal
                            convictions and offences.
                        </p>
                    </li>
                </ol>
                <h3>If you fail to provide personal data</h3>
                <ol start="11">
                    <li>
                        Where we need to collect personal data by law or under the terms of a contract we have with you and you fail to provide
                        that data when requested, we may not be able to perform the contract we have entered into with you or are trying to enter
                        into with you (for example to provide you with goods and services).  In this case we may have to cancel a product or service
                        you have with us, but we will notify you if this is the case at the time.
                    </li>
                </ol>
                <h3>How is your personal data collected?</h3>
                <ol start="12">
                    <li>
                        We may collect your personal data using the following methods:
                        <ul>
                            <li>
                                <b>Direct interactions</b><br />
                                You may give us your Identity and Contact Data by filling in forms or corresponding with us
                                by post, telephone, email or in person at trade shows and/or networking events.
                            </li>
                            <li>
                                <b>Automated technologies or interactions</b><br />
                                As you interact with our website we may automatically collect Technical Data about your equipment,
                                browsing actions and patterns.  We collect this data by using cookies and other similar technologies.
                                Please see the section entitled “Cookies” below for further details.
                            </li>
                            <li>
                                <b>Third parties or publicly available sources</b><br />
                                We may receive personal data about you from various third parties and publicly available sources.
                            </li>
                        </ul>
                    </li>
                </ol>
                <h3>How we use your personal data</h3>
                <ol start="13">
                    <li>
                        We will only use your personal data when the law allows us to.  Generally, we will use your personal data in the
                        following circumstances:
                        <ul>
                            <li>
                                where we need to perform any contract we are about to enter into or have entered into with you;
                            </li>
                            <li>
                                where it is necessary for our legitimate interests (or those of a third party) and your interests
                                and fundamental rights do not override those interests; and
                            </li>
                            <li>
                                where we need to comply with a legal or regulatory obligation.
                            </li>
                        </ul>
                    </li>
                </ol>

                <h3>Purposes for which we will use your personal data</h3>
                <ol start="14">
                    <li>
                        <p>
                            We have set out in the table below a description of all the ways in which we plan to use your personal data and which of
                            the legal bases we rely on to do so. We have also identified what our legitimate interests are where appropriate.
                        </p>
                    </li>
                    <li>
                        <p>
                            It may be that we process your personal data for more than one lawful ground depending on the specific purpose for
                            which we are using your data.  Please contact us if you need details about the specific legal ground we are relying on
                            to process your personal data where more than one ground has been set out below.
                        </p>
                        <table className="table">
                            <thead>
                                <tr>
                                    <th scope="col">Purpose / Activity</th>
                                    <th scope="col">Type of data</th>
                                    <th scope="col">Lawful basis for processing including basis of legitimate interest</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>To register you as a new customer</td>
                                    <td>	
                                         <ol type="a">
                                            <li>Identity</li>
                                            <li>Contact</li>
                                        </ol>
                                    </td>
                                    <td>Performance of a contract with you.</td>
                                </tr>
                                <tr>
                                    <td>
                                        To manage our relationship with you which will include:
                                        <ol type="a">
                                            <li>notifying you about changes to our terms or privacy policy;</li>
                                            <li>asking you for feedback or to take part in a customer survey.</li>
                                        </ol>
                                    </td>
                                    <td>
                                        <ol type="a">
                                            <li>Identity</li>
                                            <li>Contact</li>
                                            <li>Profile</li>
                                            <li>Marketing and communications</li>
                                        </ol>
                                    </td>
                                    <td>
                                        <ol type="a">
                                            <li>Performance of a contract with you;</li>
                                            <li>necessary to comply with a legal obligation;</li>
                                            <li>necessary for our legitimate interests (to keep our records updated and to study how customers use our products / services, to develop them and grow our business).</li>
                                        </ol>
                                    </td>
                                </tr>
                                <tr>
                                    <td>To administer and protect our business and this website (including troubleshooting, data analysis, testing etc)</td>
                                    <td>
                                        <ol type="a">
                                            <li>Identity</li>
                                            <li>Contact</li>
                                            <li>Technical</li>
                                            <li>Usage</li>
                                        </ol>
                                    </td>
                                    <td>Necessary for our legitimate interests (for running our business, provision of administration and IT services, network security).</td>
                                </tr>
                                <tr>
                                    <td>To make suggestions and recommendations to you about products or services that may be of interest to you</td>
                                    <td>
                                        <ol type="a">
                                            <li>Identity</li>
                                            <li>Contact</li>
                                            <li>Technical</li>
                                            <li>Usage</li>
                                            <li>Profile</li>
                                        </ol>
                                    </td>
                                    <td>Necessary for our legitimate interests (to develop our products / services and grow our business).</td>
                                </tr>
                            </tbody>
                        </table>
                    </li>
                </ol>

                <h3>Marketing and Communications</h3>
                <ol start="16">
                    <li>
                        <p>
                            We may use your Identity, Contact, Technical, Usage and Profile Data to form a view on what we think you may want or need
                            or what may be of interest to you.  This is how we decide which of our products and services may be relevant for you.
                        </p>
                    </li>
                    <li>
                        <p>
                            Although generally we do not send direct marketing communications, we may do so if you have requested information from us,
                            purchased products and/or services from us or previously provided us with your details and, in each case, you have not opted
                            out of receiving such communications.
                        </p>
                    </li>
                    <li>
                        <p>
                            We will always get your express opt-in consent before sharing any personal data with any company outside JustGoRide for
                            marketing purposes.
                        </p>
                    </li>
                    <li>
                        <p>
                            You have the right to ask us or third parties to stop sending you marketing messages at any time by simply contacting us.
                            Where you opt out of receiving these marketing messages this will not apply to personal data provided to us as a result of a
                            product / service purchase or other related transaction.
                        </p>
                    </li>
                </ol>

                <h3>Cookies</h3>
                <ol start="20">
                    <li>
                        <p>
                            You can set your browser to refuse all or some browser cookies or to alert you when websites set or access cookies.
                            If you disable or refuse cookies please note that some parts of this website may become inaccessible or not function properly.
                            Further information about cookies generally and those we use is as follows:
                        </p>
                        <ul>
                            <li>
                                <p>
                                    What are cookies?
                                </p>
                                <p>
                                    Cookies are small amounts of data (which often include a unique identifier) that are sent to your computer or mobile phone
                                    browser (referred to here as a “device”) from a website’s computer and are stored on your device’s hard drive.  Each website
                                    can send its own cookie to your browser if your browser’s preferences allow it, but to protect your privacy your browser only
                                    permits a website to access the cookies it has already sent to you, not the cookies sent to you by other websites.  Many
                                    websites do this whenever a user visits their website in order to track online traffic flows.
                                </p>
                            </li>
                            <li>
                                <p>
                                    How do we use cookies?
                                </p>
                                <p>
                                    Information supplied by cookies can help us to analyse the profile of our visitors and provide them with a better user experience.
                                    For example, if on a previous visit you went to our blog pages, we might find this out from your cookie and highlight similar
                                    stories on your second and subsequent visits.
                                </p>
                            </li>
                            <li>
                                <p>
                                    Third party cookies
                                </p>
                                <p>
                                    Please note that during your visits to our website you may notice some cookies that are not directly related to us.  When you visit a
                                    page with content embedded from YouTube, or one which has a “Share” button, you may be presented with cookies from these websites.
                                    We have no control of these cookies and you should check such third party websites for more information about these.
                                </p>
                            </li>
                            <li>
                                <p>
                                    Don’t want us to use cookies?
                                </p>
                                <p>
                                    We will not use cookies to collect personally identifiable information about you.  However, if you wish to restrict or block the cookies
                                    which are set by this site, or indeed any other website, you can do this through your browser settings.  The Help function within your
                                    browser should tell you how to do this.
                                </p>
                                <p>
                                    Alternatively, you may wish to visit www.aboutcookies.org which contains comprehensive information about how to do this on a wide variety
                                    of browsers.  You will also find details on how to delete cookies from your computer as well as more general information about cookies.
                                    For information on how to do this on the browser of your mobile phone you will need to refer to your handset manual.
                                </p>
                            </li>
                            <li>
                                <p>
                                    Cookies used by JustGoRide.co.uk
                                </p>
                                <p>
                                    _utma, _utmb, _utmc, _utmz.  We use Google Analytics to monitor traffic levels, search queries and visits to this website.  Google Analytics
                                    stores IP address anonymously on its servers in the US, and neither JustGoRide nor Google associates your IP address with any personally
                                    identifiable information.  These cookies enable Google to determine whether you are a return visitor to the site and to track the pages that you
                                    visit during your session.
                                </p>
                                <p>
                                    Session, also called a transient cookie (a cookie that is erased when the user closes the Web browser). The session cookie is stored in temporary
                                    memory and is not retained after the browser is closed.  Session cookies do not collect information from the user’s computer.
                                </p>
                            </li>
                        </ul>
                    </li>
                </ol>

                <h3>Change of purpose</h3>
                <ol start="21">
                    <li>
                        <p>
                            21.	We will only use your personal data for the purposes for which we have collected it, unless we reasonably consider that we need it for another reason and
                            that reason is compatible with the original purpose.  If you would like an explanation as to how the processing for the new purpose is compatible with the
                            original purpose then please contact us.
                        </p>
                    </li>
                    <li>
                        <p>
                            If we need to use your personal data for an unrelated purpose we will notify you and will explain the legal basis which allows us to do so.
                        </p>
                    </li>
                    <li>
                        <p>
                            Please note that we may process your personal data without your knowledge or consent in compliance with the above rules where this is required or permitted by law.
                        </p>
                    </li>
                </ol>

                <h3>Disclosures of your personal data</h3>
                <ol start="24">
                    <li>
                        <p>
                            We may have to share your personal data with the parties set out below for the purposes set out in the table in paragraph 15 above:
                        </p>
                        <ul>
                            <li>
                                external third parties – consisting of service providers (acting as processors) who provide IT and system administration services; professional advisers (acting
                                as processors or joint controllers) including lawyers, auditors and HM Revenue & Customs, regulators and other authorities (acting as processors or joint controllers)
                                who require reporting of processing activities in certain circumstances;
                            </li>
                            <li>
                                third parties to whom we may choose to sell, transfer or merge parts of our business or assets.  If a change occurs to our business then the new owners may use your
                                personal data in the same way as set out in this privacy policy.
                            </li>
                            <p>
                                We require all third parties to respect the security of your personal data and to treat it in accordance with the law.  We do not allow our third-party service providers to
                                use your personal data for their own purposes and only permit them to process your personal data for specified purposes and in accordance with our instructions.
                            </p>
                        </ul>
                    </li>
                </ol>

                <h3>Export of Personal Data outside the EU</h3>
                <ol start="25">
                    <li>
                        JustGoRide will generally not need to transfer any Personal Data it holds as Data Controller outside the EU.  In cases where it is required, JustGoRide will ensure that the necessary
                        consents and / or adequate protections are in place.
                    </li>
                </ol>

                <h3>Data Security</h3>
                <ol start="26">
                    <li>
                        We have put in place appropriate security measures to prevent your personal data from being accidentally lost, used or accessed in an unauthorised way, altered or disclosed.  In addition,
                        we limit access to your personal data to those employees, agents, contractors and other third parties who have a business need to know.  They will only process your personal data on our
                        instructions and they are subject to a duty of confidentiality.  We have put in place procedures to deal with any suspected personal data breach and will notify you and any applicable
                        regulator of a breach where we are legally required to do so.
                    </li>
                </ol>


                <h3>Data retention – how long will we use your information for?</h3>
                <ol start="27">
                    <li>
                        <p>
                            We will only retain your personal information for as long as is necessary to fulfil the purposes we collected it for, including for the purposes of satisfying any legal,
                            accounting or reporting requirements.  To determine the appropriate retention period for personal data we consider the amount, nature and sensitivity of personal data,
                            the potential risk of harm from unauthorised use or disclosure of your personal data, the purposes for which we process your personal data and whether we can achieve
                            those purposes through other means and the applicable legal requirements.
                        </p>
                    </li>
                    <li>
                        <p>
                            By law we have to keep basic information about our customers (including Contact and Identity Data) for six (6) years after they cease being customers for tax purposes.
                        </p>
                    </li>
                    <li>
                        <p>
                            In some circumstances we may anonymise your personal information (so that it can no longer be associated with you) for research or statistical purposes, in which case
                            we may use such information without further notice to you.
                        </p>
                    </li>
                </ol>


                <h3>Your legal rights</h3>
                <ol start="30">
                    <li>
                        <p>
                            In certain circumstances you have rights in relation to your personal data under data protection laws.
                        </p>
                    </li>
                    <li>
                        <u>Your duty to inform us of changes</u>
                        <p>
                            It is important that the personal information we hold about you is accurate and current.  Please keep us informed if your personal information changes during your
                            working relationship with us.
                        </p>
                    </li>
                    <li>
                        <u>Your rights in connection with personal information</u>
                        <p>
                            By law, in certain circumstances you have the right to:
                        </p>
                        <ul>
                            <li>
                                <p>
                                    <b>Request access</b> to your personal information (commonly known as a “data subject access request”).  This enables you to receive a copy of the personal
                                    information we hold about you and to check that we are lawfully processing it;
                                </p>
                            </li>
                            <li>
                                <p>
                                    <b>Request correction</b> of the personal information that we hold about you.  This enables you to have any incomplete or inaccurate information we hold
                                    about you corrected;
                                </p>
                            </li>
                            <li>
                                <p>
                                    <b>Request erasure</b> of your personal information.  This enables you to ask us to delete or remove personal information where there is no good reason
                                    for us continuing to process it.  You also have the right to ask us to delete or remove your personal information where you have exercised your right to
                                    object to processing (see below);
                                </p>
                            </li>
                            <li>
                                <p>
                                    <b>Object to processing</b> of your personal information where we are relying on a legitimate interest (or those of a third party) and there is something
                                    about your particular situation which makes you want to object to processing on this ground.  You also have the right to object where we are processing
                                    your personal information for direct marketing purposes;
                                </p>
                            </li>
                            <li>
                                <p>
                                    <b>Request the restriction of processing</b> of your personal information.  This enables you to ask us to suspend the processing of personal information
                                    about you, for example, if you want us to establish its accuracy or the reason for processing it;
                                </p>
                            </li>
                            <li>
                                <p>
                                    <b>Request the transfer</b> of your personal information to another party;
                                </p>
                            </li>
                            <li>
                                <p>
                                    <b>Withdraw your consent at any time</b> in the limited circumstances where we are relying on your consent to process your personal data.  However, this
                                    will not affect the lawfulness of any processing carried out before you withdraw your consent.  If you withdraw your consent we may not be able to provide
                                    certain products and services to you, in which case we will advise you of this at the time you withdraw your consent.  Once we have received notification
                                    that you have withdrawn your consent we will no longer process your information for the purpose or purposes you originally agreed to, unless we have another
                                    legitimate basis for doing so in law.
                                </p>
                            </li>
                        </ul>
                        <p>
                            If you would like to review, verify, correct or request erasure of your personal information, object to the processing of your personal data, request that we
                            transfer a copy of your personal information to another party or withdraw your consent then please contact us.
                        </p>
                    </li>
                    <li>
                        <u>No fee usually required</u>
                        <p>
                            You will not have to pay a fee to access your personal information (or to exercise any of your other rights).  However, we may charge a reasonable fee if your
                            request for access is clearly unfounded, repetitive or excessive.  Alternatively, we may refuse to comply with the request in such circumstances.
                        </p>
                    </li>
                    <li>
                        <u>What we may need from you</u>
                        <p>
                            We may need to request specific information from you to help us confirm your identity and ensure your right to access the information (or to exercise any of your
                            other rights).  This is a security measure to ensure that personal information is not disclosed to any person who has no right to receive it.  We may also contact
                            you to ask you for further information in relation to your request.
                        </p>
                    </li>
                    <li>
                        <u>Time limit to respond</u>
                        <p>
                            We try to respond to all legitimate requests within one (1) month.  Occasionally it may take us longer than a month if your request is particularly complex or you
                            have made a number of requests. In this case we will notify you and keep you updated.
                        </p>
                    </li>
                </ol>

                <h3>Glossary – Lawful basis</h3>
                <ol start="36">
                    <li>
                        <p>
                            <b>Legitimate interest</b> means the conducting and managing of our business to enable us to give you the best products and services and most secure experience.
                            We ensure that we consider and balance any potential impact on you and your rights before we process your personal data for our legitimate interests.  We do not
                            use your personal data for activities where our interests are overridden by the impact on you, unless we have your consent or are otherwise required or permitted
                            to by law.  You can obtain further information about how we assess our legitimate interests against any potential impact on you in respect of specific activities
                            by contacting us.
                        </p>
                    </li>
                    <li>
                        <p>
                            <b>Performance of a contract</b> means processing your data where it is necessary for the performance of a contract to which you are a party, or to take steps at
                            your request before entering into such a contract.
                        </p>
                    </li>
                    <li>
                        <p>
                            <b>Comply with a legal or regulatory obligation</b> means processing your personal data where it is necessary for compliance with a legal or regulatory obligation
                            that we are subject to.
                        </p>
                    </li>

                </ol>
            </div>
        </div>
    );

}

PrivacyPolicy.propTypes = {
    setupNavigation: PropTypes.func.isRequired
}


function mapStateToProps(state) {
    return {
    };
}

const mapDispatchToProps = {
    setupNavigation
}

export default connect(mapStateToProps, mapDispatchToProps)(PrivacyPolicy);   



// WEBPACK FOOTER //
// ./src/components/PrivacyPolicy.js